import {useQueryClient} from '@tanstack/react-query'

const useRefetchQuery = () => {
  const queryClient = useQueryClient()

  // refetch data by cache keys
  const refetchQuery = (...rest) => {
    rest.map(async item => await queryClient.refetchQueries(item))
  }

  // Get query's cached data by cache key
  const getCachedData = cacheKeys => queryClient.getQueryData(cacheKeys)

  return {refetchQuery, getCachedData}
}

export default useRefetchQuery
